export const resultsConfig = {
  ORDER_TYPES: {
    asc: {
      value: 'asc',
      order: 'asc',
      default: true,
      direction: 'up',
      title: 'Sort alphabetically A-Z',
    },
    desc: {
      value: 'desc',
      order: 'desc',
      default: true,
      direction: 'down',
      title: 'Sort alphabetically Z-A',
    },
  },

  CONTEXT: {
    citations: 'citations',
    reactions: 'reactions',
    substances: 'substances',
    targets: 'tgitems',
  },

  INITIAL_ITEMS_AMOUNT: {
    substanceBio: 7,
    substanceQuantitative: 7,
    substanceProperty: {
      fact: 7,
      children: 5,
    },
    reactionDetails: 100,
  },
  chunkSizePerContext: {
    substances: 10,
    reactions: 6,
    citations: 20,
    tgitems: 10,
  },
  CACHE_KEY_PARTS: ['resultName', 'sort', 'order', 'firstItem', 'lastItem'],
};

export const RESULTS_TEXTS = {
  zeroFilterResultsTitle: 'No results found',
  zeroFilterResults: 'Your selected filter criteria were too restrictive. Please reconsider and try again.',
  zeroGoToContextResultsText: 'No substance page available for selected compound.',
  zeroGoToContextResultsConfirmText: 'Continue',
  zeroPreparationsText: 'No preparations available.',
  zeroPreparationsConfirmText: 'Ok',
};

export const resultsColors = {
  Citations: 'extended-blue-2',
  Substances: 'extended-purple-2',
  Reactions: 'extended-teal-2',
  Tgitems: 'extended-pink-2',
  Targets: 'extended-pink-2',
  Commercialsubstances: 'extended-orange-2',
};
